import React, { useRef } from "react";
import "./introducao.css";

import PolygonDwn from "../../assets/img/introducao/i_polygon.png";
import Star from "../../assets/img/introducao/i_star.png";
import ScreenShot from "../../assets/img/introducao/i_image1.png";
import { motion, useScroll, useTransform } from "framer-motion";
import { useResolution } from "../../utils/resolutionControll";

const Introducao: React.FC = () => {
  const width = useResolution();
  const isMobile = width < 920;

  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 0.4], ["0%", "15%"]);

  return (
    <div className="introducao">
      <div className="introducao-header">
        <img
          src={PolygonDwn}
          alt="figura de um poligado com descrivos tum tá ti"
          width={"100%"}
        />
      </div>

      {isMobile ? (
        <motion.div className="octagon">
          <div className="introducao-midle-container">
            <h2>
              <img src={Star}></img>
              Fazemos
              <img src={Star}></img>
            </h2>
          </div>

          <div className="introducao-midle-content">
            <p>da música uma força de transformação, e dos instrumentos, caminhos para um novo futuro.</p>
          </div>
        </motion.div>
      ) : (
        <motion.div className="octagon" style={{ y }}>
          <div className="introducao-midle-container">
            <h2>
              <img src={Star}></img>
              Fazemos
              <img src={Star}></img>
            </h2>
          </div>

          <div className="introducao-midle-content">
            <p>da música uma força de transformação, e dos instrumentos, caminhos para um novo futuro.</p>
          </div>
        </motion.div>
      )}

      <div ref={containerRef} className="introducao-end-container">
        <img src={ScreenShot} alt="figura" className="" width={"100%"} />
      </div>
    </div>
  );
};

export default Introducao;
